module.exports = __webpack_public_path__ + "static/media/image_news.8c7e6640.png";